import * as React from 'react';
import { toast } from 'react-toastify';

import { BOTTOM_TOAST } from '../toastUtils';

// Easter egg: flip the Dark Mode switch ZOOMIES_TOGGLE_COUNT times within
// ZOOMIES_WINDOW_MS and the BARK logo does a spin (see .bark-zoomies in
// src/css/easter-eggs.css) with a toast.
const ZOOMIES_TOGGLE_COUNT = 5;
const ZOOMIES_WINDOW_MS = 3000;
const ZOOMIES_DURATION_MS = 1300; // slightly longer than the CSS animation

export const useZoomies = (onToggle: () => void) => {
  const toggleTimesRef = React.useRef<number[]>([]);
  const [isZooming, setIsZooming] = React.useState(false);

  React.useEffect(() => {
    if (!isZooming) return;
    const timer = window.setTimeout(() => setIsZooming(false), ZOOMIES_DURATION_MS);
    return () => window.clearTimeout(timer);
  }, [isZooming]);

  const handleToggle = React.useCallback(() => {
    onToggle();
    const now = Date.now();
    const recent = [...toggleTimesRef.current, now].filter(
      (time) => now - time <= ZOOMIES_WINDOW_MS
    );
    if (recent.length >= ZOOMIES_TOGGLE_COUNT) {
      toggleTimesRef.current = [];
      setIsZooming(true);
      toast('Zoomies detected 🐕', { ...BOTTOM_TOAST, toastId: 'bark-zoomies' });
    } else {
      toggleTimesRef.current = recent;
    }
  }, [onToggle]);

  return { isZooming, handleToggle };
};
